// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
// function ApiGetAllKategoriFasilitas(params: any): any {
//     const baseUrl = '/api/admin/kategorimenu';
//     return api.get(`${baseUrl}`, params);
// }
function ApiGetAllTerapis(params: any): any {
    const baseUrl = '/api/admin/terapis';
    return api.get(`${baseUrl}`, params);
}

function ApiGetReportTerapis(params: any): any {
    const baseUrl = '/api/admin/transaksireflexy';
    return api.get(`${baseUrl}`, params);
}

function ApiPostTerapis(params: any): any {
    const baseUrl = '/api/admin/terapis';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
// function ApiEditKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.update(`${baseUrl}`, params);
// }
function ApiEditTerapis(params: any, id: any): any {
    const baseUrl = '/api/admin/terapis/' + id;
    return api.update(`${baseUrl}`, params);
}
// function ApiDeleteKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.delete(`${baseUrl}`, params);
// }

export {
    // ApiGetAllKategoriMenu,
    ApiGetAllTerapis,
    ApiGetReportTerapis,
    // ApiPostCategoryRoom,
    ApiPostTerapis,
    // ApiEditKategoriRoom,
    ApiEditTerapis,
    // ApiDeleteKategoriRoom,
};
